module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        <h3 class=\"error\">";
  if (stack1 = helpers.error) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = depth0.error; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</h3>\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, depth0.product, {hash:{},inverse:self.program(10, program10, data),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n            <button class=\"btn-cart shiny-blue\">Add Product</button>\n            <h1>"
    + escapeExpression(((stack1 = ((stack1 = depth0.product),stack1 == null || stack1 === false ? stack1 : stack1.title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</h1>\n            <div class=\"content-holder\">\n                <div class=\"sub-inner\">\n                        ";
  stack2 = helpers['with'].call(depth0, depth0.product, {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n                    <!--";
  stack2 = helpers.each.call(depth0, depth0.success, {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "-->\n                </div>\n            </div>\n        ";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n\n                            <div class=\"desc\">\n                                <img src=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.constructImage || depth0.constructImage),stack1 ? stack1.call(depth0, depth0.imageref, options) : helperMissing.call(depth0, "constructImage", depth0.imageref, options)))
    + "\" class=\"product-photo\"/>\n                                ";
  if (stack2 = helpers.desc) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = depth0.desc; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "\n                            </div>\n                        ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "-->\n                        <!--";
  stack1 = helpers.each.call(depth0, depth0, {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "-->\n                    <!--";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "-->\n                            <!--";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.filterTag || depth0.filterTag),stack1 ? stack1.call(depth0, ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.key), depth0, options) : helperMissing.call(depth0, "filterTag", ((stack1 = data),stack1 == null || stack1 === false ? stack1 : stack1.key), depth0, options)))
    + "-->\n                        <!--";
  return buffer;
  }

function program10(depth0,data) {
  
  
  return "\n            <div class=\"loading black-overlay\"></div>\n        ";
  }

  buffer += "<div class=\"btn-close\">&#x2716;</div>\n\n<div class=\"popup-inner\">\n    ";
  stack1 = helpers['if'].call(depth0, depth0.error, {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });